import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`About`}</h2>
    <p>{`👋 👋 👋 I currently work as a Product Manager at Snap focusing on building communities around user-generated content. In my spare time, I like to capture the nuances of human emotions via my photography business, `}<a href="https://www.xiongstudio.com" target="_blank" rel="noopener noreferrer">{`Xiong Studio`}</a>{`, explore our Planet Earth, and read about design, history, society and philosophy.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      